import { createSlice } from "@reduxjs/toolkit";
import { getCompanyList } from "../../reduxApi/admin/CompanyReduxApi";

const companySlice = createSlice({
    name: 'company',
    initialState: {
        status: 'idel',
        isFiltered: false,
        company: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteCompanyAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.company.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.company.splice(index, 1);
                }
            });
        },
        updateCompanyAction: (state, action) => {
            const index = state.company.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.company.splice(index, 1, { companys: action.payload })
            }
        },
        addCompanyAction: (state, action) => {
            console.log("action--->",action.payload);
            
            const temp = action.payload;
            console.log("temp",temp)
            temp.ROWID = action.payload.ROWID;
            console.log("temp.ROWID",temp.ROWID);
            
            state.company.unshift( temp ); //add new data at beginning of array 
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getCompanyList.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getCompanyList.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                state.company = action.payload.data.companies;
            })
    }
})
export const { deleteCompanyAction, updateCompanyAction, addCompanyAction, setFilteredStatus } = companySlice.actions
export default companySlice.reducer